<script setup>
import { formatDateString } from '@/composables/helpers/dates';

const props = defineProps({
    page: {
        type: Object,
        required: false,
    },
});

const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
</script>

<template>
    <div class="blog-headline mx-auto max-w-225 text-(--magenta) mb-13 mt-12.25 max-lg:pt-4">
        <div class="category-date flex flex-wrap items-center mb-4 gap-2">
            <ProjectTag category :link="`/blog?category=${page.data.category.toLowerCase()}`" :text="page.data.category" colorSet="magenta" :useHover="true" :useX="false" gtmEventName="blog_category_tag_clicked" />
            <time class="font-hubspot-sans text-[12px] font-medium tracking-[0.84px] uppercase ml-6 mr-6" :datetime="formatDateString(page.data.datePublished)">{{formatDateString(page.data.datePublished)}}</time>
            <template v-if="page.data.tags?.length">
                <NuxtLink v-for="tag in page.data.tags" :key="tag"
                    :to="`/blog/?tags=${encodeURIComponent(tag)}`"
                    class="border border-(--magenta) rounded-full px-[10px] no-underline
                        font-hubspot-sans font-normal text-[12px] leading-[26px] tracking-[0.24px] text-(--magenta)
                        transition-colors duration-200 hover:bg-(--magenta) hover:text-white">
                    {{ tag }}
                </NuxtLink>
            </template>
        </div>
        <h1 class="h2 font-hubspot-serif font-normal leading-[1.1] tracking-normal text-(--magenta)">{{ page.data.title }}</h1>
        <div class="tags-share flex mt-7 text-(--dark-pink) max-lg:flex-wrap max-lg:gap-8">
            <FragmentsShare :title="page.data.title" />
        </div>
    </div>
</template>

<style>
/* [child] — share component link styling */
.blog-headline .tags-share a {
    color: var(--dark-pink);
}

.blog-headline .tags-share a:hover {
    color: var(--magenta);
}
</style>
